import React from 'react';
import HeroUltimate from '../components/HeroUltimate';
import TrustedPartners from '../components/TrustedPartners';
import SimpleSteps from '../components/SimpleSteps';
import TrustSection from '../components/TrustSection';
import SimpleFAQ from '../components/SimpleFAQ';
import FinalCTA from '../components/FinalCTA';

const HomePage = () => {
  return (
    <div>
      <HeroUltimate />
      <TrustedPartners />
      <SimpleSteps />
      <TrustSection />
      <SimpleFAQ />
      <FinalCTA />
    </div>
  );
};

export default HomePage;